<template>
    <div>
        <el-row style="margin-top: 20px" :gutter="20">
            <template v-for="(item,i) in data.list">
                <el-col :key="i" :span="4">
                    <div class="itemEvent"
                         style="line-height: 175px;cursor: pointer;"
                         @click="toEventTool(item.id,item.name)">
                            {{item.name}}
                            <i class="el-icon-star-on itemStar" v-if="item.start=='Y'"></i>
                    </div>
                </el-col>
            </template>
        </el-row>

        <!--分页-->
        <div class="page">
            <el-pagination
                background
                @current-change="loadData"
                :current-page="params.page"
                layout="total, prev, pager, next, jumper"
                :page-size="data.pageSize"
                :total="data.total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
import request from "../../common/request";
import utils from "../../common/utils";
import api from "../../common/api";

export default {
  metaInfo: {
    title: '事件风暴-公共风暴', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '事件风暴,EventStorming,Big Picture,Design Level,DDD,CQRS,ES'
    }, {
      name: 'description',
      content: '事件风暴EventStorming 是一个单一的大型研讨会，涉及我们期望合作解决关键业务问题的所有关键人员。 我们将建立整个业务线的行为模型，突出协作、边界、责任以及相关参与者和利益相关者的不同观点'
    }],
  },
  name: "DataListOpen",
  data: function () {
    return {
      value2: 1,
      loading: false,
      params: {
        page: 1,
        name: "",
      },
      data: {
        pageSize: 0,
        total: 0,
        list: [
          {
            createdAt: "",
            id: "",
            name: "",
            updatedAt: ""
          }
        ],
      },
      isList: true,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    //加载数据
    loadData: function (page) {
      let params = Object.assign({}, this.params);
      if (!utils.isEmpty(page)) {
        params.page = page;
      }
      this.loading = true;
      request.post(api.DataListOpen, params).then((data) => {
        this.data = data;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error(error)
      });

    },
    toEventTool: function (id, name) {
      //this.$router.push({name: 'EventToolOpen', blank:true, query: {name: name, id: id}})
      //新窗口打开
      let routeData = this.$router.resolve({
        name: 'EventToolOpen',
        params: { id: id, name: name },
      })
      window.open(routeData.href, '_blank');

    },
  }
}
</script>

<style scoped>
.itemStar {
  position: absolute;
  top: 10px;
  right: 10px;
  color: rgb(247, 186, 42);
}
</style>
